/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var beforePrimaryToolbarPluginWrapperStyles = css({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-end',
  alignItems: 'center'
});
// Duplicate of the wrapper from `editor-plugins/before-primary-toolbar` used
// only in `FullPageToolbar` to decouple the plugin from the main toolbar
export var BeforePrimaryToolbarWrapper = function BeforePrimaryToolbarWrapper(props) {
  return jsx("div", {
    css: beforePrimaryToolbarPluginWrapperStyles,
    "data-testid": 'before-primary-toolbar-components-plugin'
  }, props.beforePrimaryToolbarComponents);
};